const BODY_TAGS = {
  ABBR: "abbr",
  CAPTION: "caption",
  P: "p",
  SPAN: "span",
  TIME: "time"
};
const DISPLAY_TAGS = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
};
const ALL_TAGS = { ...BODY_TAGS, ...DISPLAY_TAGS };
const DISPLAY_VARIANTS = {
  DISPLAY_5XL: "display-5xl",
  DISPLAY_4XL: "display-4xl",
  DISPLAY_3XL: "display-3xl",
  DISPLAY_2XL: "display-2xl",
  DISPLAY_XL: "display-xl",
  DISPLAY_LG: "display-lg",
  DISPLAY_MD: "display-md",
  DISPLAY_SM: "display-sm",
  DISPLAY_XS: "display-xs"
};
const BODY_VARIANTS = {
  BODY_LG: "body-lg",
  BODY_MD: "body-md",
  BODY_SM: "body-sm"
};
const ALL_VARIANTS = { ...DISPLAY_VARIANTS, ...BODY_VARIANTS };
const FONT_WEIGHTS = {
  REGULAR: "regular",
  MEDIUM: "medium",
  BOLD: "bold"
};
const ALIGNMENTS_ENUMS = {
  START: "start",
  CENTER: "center",
  END: "end"
};
const DEFAULT_COLOR = "default";
export {
  ALIGNMENTS_ENUMS,
  ALL_TAGS,
  ALL_VARIANTS,
  BODY_TAGS,
  BODY_VARIANTS,
  DEFAULT_COLOR,
  DISPLAY_TAGS,
  DISPLAY_VARIANTS,
  FONT_WEIGHTS
};
//# sourceMappingURL=constants.mjs.map
